import Loadable from 'react-loadable';
import { LCLoading } from 'control/loading';

const ForgetPassword = Loadable({
  loader: () => import('./forgetpassword'),
  loading: LCLoading,
});
export { ForgetPassword };
